import React from "react";
import dataServices from './servicesData'
const Services = () => {
  const click = (e) => {
    e.preventDefault();
  }
  return (
    <section className="ftco-section clases " id="services">
      <div className="container-fluid px-md-5 color">
        <div className="row justify-content-center py-5">
          <div className="col-md-12 heading-section text-center ftco-animate">
            <h1 className="big big-2">Servicios</h1>
            <h2 className="mb-4 text-uppercase colorTexto">Servicios</h2>
            <p>
              Los diferentes servicios que ofrezco
            </p>
          </div>
        </div>
        <div className="row " >
          {dataServices.map((data, index) => (
            <div key={index} className="col-md-6 col-sm-8 col-lg-4 text-center d-flex ftco-animate mx-auto">
              <a href="/#" className="services-1 shadow box" onClick={click}>
                <span className="icon">
                  <i className={data.class}></i>
                </span>
                <div className="desc">
                  <h3 className="mb-5" style={{ color: '#007BFF' }}> {data.title}</h3>
                  <p>
                    {data.description}
                  </p>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;